import { THEME } from 'bora-material-ui/themes'

export const isSaaremaa = window.brandProps.theme === THEME.SAAREMAA
